module.exports = __webpack_public_path__ + "static/media/IW-Logo.07b4b678.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/IW-Logo.jpg
 ** module id = 178
 ** module chunks = 0
 **/